import { type TeamPledgeDistributionDTO, useSettings } from '@capsicum/common';
import { useMemo } from 'react';

import { usePledgeCampaignLeaderboardQuery } from '../data-access/queries';

import { useWCPledgeCampaignDetails } from './useWCPledgeCampaignDetails';

type UseWCPledgeLeaderboardReturn = {
	isLoading: boolean;
	leaderboardMaxTeams: number;
	leaderboardTeams: Array<TeamPledgeDistributionDTO>;
};

export const useWCPledgeLeaderboard = (): UseWCPledgeLeaderboardReturn => {
	const { campaignId, isPledgeCampaignDetailsLoading } = useWCPledgeCampaignDetails();
	const {
		settings: { lockerRoomInternationalsConfig }
	} = useSettings();
	const leaderboardMaxTeams = lockerRoomInternationalsConfig.leaderboardMaxTeams;

	const { data: leaderboardData, isLoading: isLeaderboardLoading } = usePledgeCampaignLeaderboardQuery({
		campaign: campaignId ?? '',
		'details[]': ['teamImages']
	});

	const leaderboardTeams = useMemo(() => {
		if (!leaderboardData?.length) return [];

		return leaderboardData.slice(0, leaderboardMaxTeams);
	}, [leaderboardData, leaderboardMaxTeams]);

	return {
		isLoading: isPledgeCampaignDetailsLoading || isLeaderboardLoading,
		leaderboardMaxTeams,
		leaderboardTeams
	};
};
